import { State, Action, StateContext, Selector, NgxsOnInit } from '@ngxs/store';
import { EditPaintStateModel } from './edit.paint.state.model';
import { SetColorRecipe, ClearColorRecipe, ResetPaint } from './edit.paint.actions';
import { PaintPresetRed } from 'src/app/engine/models/paint-presets.const';
import { PaintDefaults } from '../../models/paint-defaults.model';
import { ScalarFresnelModel } from '../../models/scalar-fresnel.model';
import { ColorFresnelModel } from '../../models/color-fresnel.model';
import { ColorUtils } from 'src/app/shared/libraries/colors/colors';

const initialState = {
  colorRecipe: PaintPresetRed.recipe
};

@State<EditPaintStateModel>({
  name: 'editPaint',
  defaults: initialState 
})
export class EditPaintState {
  /**
   * Selectors
   */
  @Selector()
  static getColorRecipe(state: EditPaintStateModel) {
    return state.colorRecipe;
  }

  /**
   * Actions
   */
  @Action(SetColorRecipe)
  setColorRecipe(context: StateContext<EditPaintStateModel>, action: SetColorRecipe) {
    const recipe = {...action.colorRecipe};
    
    // When recipe matches defaults, don't include the actual value and just set it to false.
    // This indicates to the serializer that the value doesn't need to be included on an object,
    // resulting in a smaller package size.
    recipe.brightness = (recipe.brightness !== PaintDefaults.brightness) ? recipe.brightness : false;
    recipe.opacity = (recipe.opacity !== PaintDefaults.opacity) ? recipe.opacity : false;
    recipe.contrast = (recipe.contrast !== PaintDefaults.contrast) ? recipe.contrast : false;
    recipe.saturation = (recipe.saturation !== PaintDefaults.saturation) ? recipe.saturation : false;

    if (!(recipe.opacity instanceof ScalarFresnelModel)) {
      recipe.opacity = (recipe.opacity !== PaintDefaults.opacity) ? recipe.opacity : false;
    }
    
    if (!(recipe.tintColor instanceof ColorFresnelModel)) {
      const tintColor = (typeof recipe.tintColor === 'string') ? ColorUtils.hexToRgb(recipe.tintColor, true) : recipe.tintColor;
      recipe.tintColor = (tintColor.toString() !== PaintDefaults.tintColor.toString()) ? tintColor : false;
    }

    context.patchState({
      colorRecipe: { ...recipe }
    });
  }

  @Action(ClearColorRecipe)
  clearColorRecipe(context: StateContext<EditPaintStateModel>, action: ClearColorRecipe) {
    context.patchState({
      colorRecipe: null
    });
  }
  
  @Action(ResetPaint)
  resetPaint(context: StateContext<EditPaintStateModel>, action: ResetPaint) {
    context.setState(initialState);
  }

  constructor(
  ) { }
}
